<template>
<div>
    <v-row>
      <v-col cols="12" md="12">
        <GenricLoading v-bind:loadingStatus.sync="this.loaderValue" />
        <Search />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" class="no-padding" >
        <FooterMenu />
      </v-col>
    </v-row>
</div>
</template>

<script>
import Search from "@/components/Search";
import FooterMenu from "@/components/footer/FooterMenu";
import GenricLoading from "@/components/loading/GenricLoading";
import GetToken from "../middleware/GetToken";
import utils from "../utilities/utils";
export default {
  name: "MainPage",
  components: {
    Search,
    FooterMenu,
    GenricLoading
  },
  data: () => ({
    loaderValue: true
  }),
  created() {
    const tokenVal = utils.getCookies();
    if (tokenVal === undefined || tokenVal == "") {
      this.authorizeUser();
    } else {
      this.loaderValue = false;
    }
  },
  methods: {
    async authorizeUser() {
      try {
        var resp = await GetToken.getAuthorizationToken();
        this.loaderValue = false;
        utils.setCookies(resp.data.Token);
      } catch (e) {
        this.$router.push({ path: `/404` });
      }
    }
  }
};
</script>
<style scoped>
.no-padding{
    width: 100%;
     padding: 0px !important; 
}
</style>
